module.exports = __webpack_public_path__ + "img/BKGG1.f62ece02.jpg";